import Translatable from '@src/mixins/translatable.js'

export default {
  methods: {
    authorLabel(pageData) {
      return pageData.mainImage && pageData.mainImage.author ?`${this.getTranslatedContent('HEADER_photo_by_label')} ${pageData.mainImage.author}` : ''
    }
  },
  mixins: [
    Translatable
  ],
}
